import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadCoverageServerListEpic } from './_epics/loadCoverageServerList.epic';
import { createCoverageServerEpic } from './_epics/createCoverageServer.epic';
import { updateCoverageServerEpic } from './_epics/updateCoverageServer.epic';
import { removeCoverageServerEpic } from './_epics/removeCoverageServer.epic';

export const coverageServerEpic = safeCombineEpics(
  loadCoverageServerListEpic,
  createCoverageServerEpic,
  updateCoverageServerEpic,
  removeCoverageServerEpic,
);
